<template>
  <div class="wrapper">
    <q-linear-progress v-if="this.isFetching" indeterminate />
    <div v-else>
      <div class="header">
        <h6 class="desc">
          {{ `Кв. ${this.objectInfo?.header?.flat_num || ''}${this.objectInfo?.header?.room_name ? `, ${this.objectInfo?.header?.room_name}` : ''}`
          }}
        </h6>
        <q-btn
          v-if="!this.editingMode"
          class="footer__btn"
          label="Редактировать"
          icon="edit"
          color="orange"
          size="sm"
          style=""
          @click="toggleEdit"
        />
      </div>

      <div class="items" v-if="this.objectInfo?.data && !this.editingMode">
        <div>
          <span
            style="font-weight: 500;"
            v-if="!!this.objectInfo?.data?.param_name_height"
            >{{ this.objectInfo?.data?.param_name_height }}:
          </span>
          <span>{{ this.objectInfo?.data?.param_value_height }}</span>
        </div>
        <div>
          <span
            style="font-weight: 500;"
            v-if="!!this.objectInfo?.data?.param_name_width"
            >{{ this.objectInfo?.data?.param_name_width }}:
          </span>
          <span>{{ this.objectInfo?.data?.param_value_width }}</span>
        </div>
        <div>
          <span style="font-weight: 500;"
            >{{ `Объем${this.objectInfo?.header?.is_has_relative ? ' первого' : ''} конструктива: ` }}
          </span>
          <span>{{ this.objectInfo?.data?.main_volume }}</span>
        </div>
        <div v-if="this.objectInfo?.header?.is_has_relative">
          <span style="font-weight: 500;">Второй конструктив: </span>
          <span
            >{{ this.objectInfo?.data?.floor_param_type_name_relative }}</span
          >
        </div>
        <div v-if="this.objectInfo?.header?.is_has_relative">
          <span style="font-weight: 500;">Объем второго конструктива: </span>
          <span>{{ this.objectInfo?.data?.second_volume }}</span>
        </div>
        <div v-if="this.objectInfo?.data?.floor_param_type_code === 'FRAME'">
          <span style="font-weight: 500;">Третий конструктив: </span>
          <span>{{ this.objectInfo?.data?.floor_param_type_name_third }}</span>
        </div>
        <div v-if="this.objectInfo?.data?.floor_param_type_code === 'FRAME'">
          <span style="font-weight: 500;">Объем третьего конструктива: </span>
          <span>{{ this.objectInfo?.data?.third_volume }}</span>
        </div>
        <div v-if="!!this.objectInfo?.data?.frame_name">
          <span style="font-weight: 500;">Конструкция: </span>
          <span>{{ this.objectInfo?.data?.frame_name }}</span>
        </div>
      </div>

      <div
        v-if="!this.editingMode && this.showFooter"
        class="paramObjectFooter"
      >
        <q-tabs
          v-model="activeTab"
          dense
          class="text-grey"
          active-color="primary"
          indicator-color="primary"
          align="justify"
          narrow-indicator
        >
          <q-tab
            v-if="this.objectInfo?.header?.is_has_relative"
            name="constructions"
            label="Параметры"
          />
          <q-tab
            v-if="this.data?.canChooseMaterial"
            name="materials"
            label="Материалы"
          />
        </q-tabs>
        <q-separator />
        <q-tab-panels v-model="activeTab" animated>
          <q-tab-panel
            name="constructions"
            v-if="this.objectInfo?.header?.is_has_relative"
          >
            <div className="frameTable">
              <CustomTable
                :rows-data="this.objectInfo?.frame_info"
                :columns="this.frameColumns"
                :custom-body="true"
              >
                <template #customBody="props">
                  <q-tr>
                    <custom-table-cell align="left">
                      {{ props.row.frame_param_type_name }}
                    </custom-table-cell>
                    <custom-table-cell align="right">
                      {{ props.row.param_value }}
                    </custom-table-cell>
                  </q-tr>
                </template>
              </CustomTable>
            </div>
          </q-tab-panel>

          <q-tab-panel name="materials" v-if="this.data?.canChooseMaterial">
            <div class="materials-section">
              <div class="materials-header">
                <q-btn
                  :color="this.materialsList?.length ? 'deep-orange-6' : 'primary'"
                  :icon="this.materialsList?.length ? 'edit' : 'add'"
                  :label="`${this.materialsList?.length ? 'Редактировать' : 'Добавить'} материалы`"
                  size="sm"
                  @click="openMaterialsModal"
                  :loading="materialsLoading"
                />
              </div>

              <div v-if="materialsList?.length" class="materials-table">
                <p
                  style="font-size: 14px; margin-bottom: 10px; padding-left: 15px;"
                >
                  Набор:
                  <span
                    style="font-weight: 500;"
                    >{{ this.materialsList[0]?.set_name || '' }}</span
                  >
                </p>
                <CustomTable
                  :rows-data="materialsList"
                  :columns="materialsColumns"
                  :custom-body="true"
                  :hideTopTitle="true"
                >
                  <template #customBody="props">
                    <q-tr>
                      <custom-table-cell align="left" vertical-align="center">
                        {{ props.row.material_name }}
                      </custom-table-cell>
                      <custom-table-cell align="center" vertical-align="center">
                        {{ props.row.param_value }}
                      </custom-table-cell>
                      <custom-table-cell align="center" vertical-align="center">
                        <div class="actions">
                          <CustomIcon
                            icon="trash"
                            :loading="deletingMaterialId === props.row.floor_param_material_id"
                            :approve-mode="true"
                            :approve="() => deleteMaterial(props.row.floor_param_material_id)"
                            class="action-icon"
                          />
                        </div>
                      </custom-table-cell>
                    </q-tr>
                  </template>
                </CustomTable>
              </div>

              <NotFoundText v-else text="Материалы не добавлены" />
            </div>
          </q-tab-panel>
        </q-tab-panels>
      </div>

      <NotFoundText v-if="!this.objectInfo?.data && !this.editingMode" />
      <q-form @submit="this.onSubmit" v-if="this.editingMode">
        <div class="ms-form-grid">
          <CustomInput
            :label="this.objectInfo?.data?.param_name_height"
            type="number"
            :value="this.formData.param_value_height"
            @change_input="(value) => onChange('param_value_height', value)"
          />
          <CustomInput
            :label="this.objectInfo?.data?.param_name_width"
            type="number"
            :value="this.formData.param_value_width"
            @change_input="(value) => onChange('param_value_width', value)"
          />
          <CustomSelect
            :options="this.paramTypes || []"
            label="Конструктив"
            optionValueKey="floor_param_type_id"
            optionLabelKey="floor_param_type_name"
            :value="this.formData.floor_param_type_id || ''"
            @change="value => this.onChange('floor_param_type_id', value)"
          />
          <CustomSelect
            v-if="this.objectInfo?.header?.is_has_relative"
            :options="this.paramTypes || []"
            label="Второй конструктив"
            optionValueKey="floor_param_type_id"
            optionLabelKey="floor_param_type_name"
            :value="this.formData.floor_param_type_id_relative || ''"
            @change="value => this.onChange('floor_param_type_id_relative', value)"
          />
          <CustomSelect
            v-if="this.objectInfo?.data?.floor_param_type_code === 'FRAME'"
            :options="this.paramTypes || []"
            label="Третий конструктив"
            optionValueKey="floor_param_type_id"
            optionLabelKey="floor_param_type_name"
            :value="this.formData.floor_param_type_id_third || ''"
            @change="value => this.onChange('floor_param_type_id_third', value)"
          />
          <CustomSelect
            :options="this.frames || []"
            label="Конструкция"
            optionValueKey="frame_id"
            optionLabelKey="frame_name"
            :value="this.formData.frame_id || ''"
            @change="value => this.onChange('frame_id', value)"
          />
        </div>
        <CustomModalFooter
          :btn-loading="this.loading"
          :onCancel="this.toggleEdit"
        />
      </q-form>
    </div>

    <FloorSchemaMaterialsModal
      v-if="materialsModalOpen"
      v-model="materialsModalOpen"
      :floor-param-id="this.objectInfo?.header?.floor_param_id"
      :floor-map-id="this.data?.floorMapId"
      :edit-materials="editingMaterials"
      :onSubmit="onMaterialsSaved"
    />
  </div>
</template>

<script>
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";
import NotFoundText from "@/components/common/NotFoundText.vue";
import PopupConfirm from "@/components/common/PopupConfirm";
import CustomInput from "@/components/form/CustomInput";
import CustomSelect from "@/components/form/CustomSelect";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import { appActions } from "@/services/store/modules/app_module/app_actions";
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import CustomIcon from "@/components/common/CustomIcon";
import FloorSchemaMaterialsModal from "@/views/ResidentialSettings/addMaterials";
import { getFloorParamFrames, getFloorParamTypes, getSchemaObjectInfo, updateFloorMapLine, frameColumns, deleteFloorParamMaterial } from "@/views/ResidentialSettings/services";

export default {
  name: "floor-schema-object-info",
  components: {
    NotFoundText,
    PopupConfirm,
    CustomInput,
    CustomModalFooter,
    CustomSelect,
    CustomTable,
    CustomTableCell,
    CustomIcon,
    FloorSchemaMaterialsModal
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      frameColumns,
      loading: false,
      isFetching: false,
      editingMode: false,
      objectInfo: null,
      formData: {},
      paramTypes: [],
      frames: [],
      activeTab: 'constructions',
      materialsModalOpen: false,
      materialsLoading: false,
      materialsList: [],
      editingMaterials: null,
      deletingMaterialId: null,
      materialsColumns: [
        {
          name: "material_name",
          label: "Материал",
          field: "material_name",
          align: "left",
        },
        {
          name: "param_value",
          label: "Количество",
          field: "param_value",
          align: "center",
        },
        {
          name: "actions",
          label: "Действия",
          field: "actions",
          align: "center",
        },
      ],
    };
  },
  methods: {
    handleRes(res) {
      if(!res) return
      this.objectInfo = res || {}
      if(res?.data) {
        const {param_value_height, param_value_width, floor_param_type_id, floor_param_type_id_relative, floor_param_type_id_third, frame_id} = res.data
        this.formData = {param_value_height, param_value_width, floor_param_type_id, floor_param_type_id_relative, floor_param_type_id_third, frame_id,
          floor_param_id: res?.header?.floor_param_id}
      }
      if(res?.materials) {
        this.materialsList = res.materials
      }
      this.setActiveTab()
    },
    setActiveTab() {
      if (this.objectInfo?.header?.is_has_relative) {
        this.activeTab = 'constructions'
      } else if (this.data?.canChooseMaterial) {
        this.activeTab = 'materials'
      }
    },
    async getData() {
      this.isFetching = true;
      const res = await getSchemaObjectInfo(this.data?.data?.floor_param_id, this.data?.params?.project_type_id)
      this.isFetching = false;
      this.handleRes(res)
    },
    async onSubmit() {
      this.loading = true
      const res = await updateFloorMapLine(this.formData, {project_type_id: this.data?.params?.project_type_id, floor_param_id: this.formData.floor_param_id})
      this.loading = false
      if(!res) return
      this.toggleEdit()
      this.showSucceedSnackbar()
      this.$store.commit(appActions.changeModalTitle(`${res?.data?.floor_param_type_name} (ID: ${res?.header?.floor_param_id})`));
      this.handleRes(res)
      this.data?.onSubmit && this.data.onSubmit()
    },
    toggleEdit() {
      this.editingMode = !this.editingMode
    },
    onChange(key, value) {
      this.formData[key] = value
    },
    async getParamTypes() {
      const res = await getFloorParamTypes()
      this.paramTypes = res
    },
    async getParamFrames() {
      const res = await getFloorParamFrames(this.data?.resident_id)
      this.frames = res
    },
    editMaterial() {
      this.editingMaterials = [...this.materialsList]
      this.materialsModalOpen = true
    },
    openMaterialsModal() {
      if(this.materialsList?.length) {
        return this.editMaterial()
      }
      this.editingMaterials = null
      this.materialsModalOpen = true
    },
    async deleteMaterial(floor_param_material_id) {
      this.deletingMaterialId = floor_param_material_id
      const res = await deleteFloorParamMaterial(this.objectInfo?.header?.floor_param_id, floor_param_material_id)
      this.deletingMaterialId = null
      if(!res) return
      this.handleRes(res)
      this.data?.onSubmit && this.data.onSubmit()
      this.showSucceedSnackbar()
    },
    onMaterialsSaved(res) {
      this.handleRes(res)
      this.data?.onSubmit && this.data.onSubmit()
    },
  },
  computed: {
    showFooter() {
      return this.data?.canChooseMaterial || this.objectInfo?.header?.is_has_relative
    },
  },
  mounted() {
    this.getData()
    this.getParamTypes()
    this.getParamFrames()
  },
  setup() {
    const {showSucceedSnackbar} = useCustomSnackbar()
    return {showSucceedSnackbar}
  }
};
</script>

<style scoped lang="scss">
.wrapper {
  min-width: min(450px, 100%);
}

.items {
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding-top: 15px;
  border-top: 1px solid var(--ms-border);
}
.paramObjectFooter {
  margin-top: 25px;
}
.desc {
  font-size: 14px;
  color: var(--ms-text);
  line-height: 1;
  margin: 0;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
  margin-top: 10px;
}

.materials-section {
  padding: 16px 0;
}

.materials-header {
  margin-bottom: 16px;
}

.materials-table {
  margin-top: 16px;
}

.actions {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.action-icon {
  cursor: pointer;
  padding: 4px;
}
</style>
